import { render, staticRenderFns } from "./StepperSubmit.vue?vue&type=template&id=a57beef8"
import script from "./StepperSubmit.vue?vue&type=script&lang=ts"
export * from "./StepperSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports